import MVtext from '../molecules/MVtext';
import { Box } from '@mui/material';
import ImageRotator from '../atoms/ImageRotator';

const images = ['/images/photo/Image1.webp', '/images/photo/Image2.webp', '/images/photo/Image3.webp'];

/**
 * メインビジュアルモーション
 * @returns 
 */
const MVmotion = () => {
  return (
    <Box sx={{height: {xs: 'calc(min(62vw, 300px) + 160px)', md: '80vh'}, position: 'relative'}}>
      <ImageRotator images={images}/>
      <MVtext/>
    </Box>
  );
};

export default MVmotion;
